import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LogService } from '../services/log/log.service';
import { Observable } from 'rxjs';
import { AppConfig } from '../../app.config';

export function logInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const sessionUuid = inject(LogService).sessionUuid();
  const issuerUrl = inject(AppConfig).oidcConfig?.issuer;
  if (issuerUrl && req.url.includes(issuerUrl)) {
    return next(req);
  }
  const newReq = req.clone({
    headers: req.headers.append('requestId', sessionUuid)
  });
  return next(newReq);
}
